export const getWindow = () => {
  /** @type {Partial<Window> & { [key: string]: any }} */
  const $window = typeof window === "undefined" ? {} : window;
  return $window;
};
